import { getJobIds } from '../../lib/rulesBasedPricingHelpers';
import {
  ADD_JOB,
  CLEAR_JOBS_ONLY,
  CLEAR_SELECTED_JOBS,
  CREATE_JOB_MATCH,
  GET_AGING_FACTORS_FAILED,
  GET_AGING_FACTORS_START,
  GET_AGING_FACTORS_SUCCESS,
  GET_JOB_UDFS_FAILED,
  GET_JOB_UDFS_START,
  GET_JOB_UDFS_SUCCESS,
  GET_ORG_JOBS_BY_ID_FAILED,
  GET_ORG_JOBS_BY_ID_START,
  GET_ORG_JOBS_BY_ID_SUCCESS,
  GET_RANDOM_PRICED_JOB_SUCCESS,
  RESET_LOADING_STATE,
  SELECT_ALL_FILTERED_JOBS,
  SET_JOB_CODE_KEYS,
  SET_ORG_JOB_FACET_TEXT,
  SET_SELECTED_JOB,
  TOGGLE_SELECT_ALL_ORG_JOBS,
  TOGGLE_SELECTED_JOB,
  TOGGLE_SHOW_SELECTED_JOBS,
  UPDATE_JOB_MATCHES_VALUES_FAILED,
  UPDATE_JOB_MATCHES_VALUES_START,
  UPDATE_JOB_MATCHES_VALUES_SUCCESS,
  UPDATE_SELECTED_JOB_MATCHES
} from './OrgJobsActions';

const initialState = {
  isLoading: false,
  isSelected: true,
  isLoadingFailed: false,
  jobCodeKeys: [],
  jobs: [],
  randomOrgJob: null,
  searchText: '',
  selectedJob: {},
  selectedJobs: [],
  userDefinedFields: [],
  isUserDefinedFieldsLoading: false,
  isUserDefinedFieldsLoaded: false,
  hasGetUserDefinedFieldsError: false,
  isUpdatingJobMatchesValues: false,
  isUpdatingJobMatchesValuesFailed: false,
  isSummaryUpdated: false,
  agingFactors: [],
  isAgingFactorsLoading: false,
  isAgingFactorsLoadFailed: false,
  isAgingFactorsLoaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case RESET_LOADING_STATE:
      return {
        ...state,
        isLoading: false,
        isLoadingFailed: false
      };
    case ADD_JOB: {
      // If the job is already selected, then remove it
      let newJobs = [];
      let isAlreadySelected = false;
      state.jobs.forEach(job => {
        if (job.id === action.data.id) {
          isAlreadySelected = true;
        }
      });

      if (isAlreadySelected) {
        newJobs = state.jobs.filter(job => {
          return job.id !== action.data.id;
        });
      } else {
        newJobs = [...state.jobs, action.data];
      }

      return {
        ...state,
        jobs: newJobs
      };
    }
    case CLEAR_JOBS_ONLY: {
      const currentSelections = action.data.map(job => job.orgJobId);
      const newSelections = state.selectedJobs.filter(selection => !currentSelections.includes(selection.orgJobId));

      return {
        ...state,
        selectedJobs: action.data.length > 0 ? newSelections : []
      };
    }
    case CLEAR_SELECTED_JOBS: {
      return {
        ...state,
        jobs: [],
        isSelected: true,
        searchText: '',
        selectedJob: {},
        selectedJobs: []
      };
    }
    case CREATE_JOB_MATCH: {
      let jobMatches;
      if (!state.selectedJob.jobMatches) {
        jobMatches = [];
      } else {
        jobMatches = state.selectedJob.jobMatches.concat({
          id: action.data.id,
          orgJob: action.data.orgJob,
          surveyJob: action.data.surveyJob
        });
      }
      return {
        ...state,
        selectedJob: {
          ...state.selectedJob,
          jobMatches
        }
      };
    }
    case GET_RANDOM_PRICED_JOB_SUCCESS: {
      return {
        ...state,
        randomOrgJob: action.orgJob
      };
    }
    case SELECT_ALL_FILTERED_JOBS: {
      const currentSelections = state.selectedJobs.map(job => job.orgJobId);
      const newSelections = action.data.filter(selection => !currentSelections.includes(selection.orgJobId));

      return {
        ...state,
        selectedJobs: state.selectedJobs.concat(newSelections)
      };
    }
    case SET_JOB_CODE_KEYS: {
      return {
        ...state,
        jobCodeKeys: action.data
          .map(value => value.jobCodeKey)
          .filter(value => {
            return value !== state.selectedJob.codeKey;
          })
      };
    }
    case SET_ORG_JOB_FACET_TEXT: {
      return {
        ...state,
        searchText: action.data
      };
    }
    case SET_SELECTED_JOB: {
      return {
        ...state,
        selectedJob: action.data
      };
    }
    case TOGGLE_SELECT_ALL_ORG_JOBS: {
      const selectedJobIds = getJobIds(state.selectedJobs);
      const orgJobsToAdd = action.data.filter(job => {
        return !selectedJobIds.includes(job.orgJobId);
      });
      const orgJobIds = getJobIds(action.data);
      const newSelectedJobs =
        state.selectedJobs.length > 0 && orgJobsToAdd.length > 0
          ? state.selectedJobs.concat(orgJobsToAdd)
          : orgJobsToAdd.length === 0
          ? state.selectedJobs.filter(job => !orgJobIds.includes(job.orgJobId))
          : action.data;

      return {
        ...state,
        selectedJobs: !state.isSelected ? [] : newSelectedJobs
      };
    }
    case TOGGLE_SELECTED_JOB: {
      let newJobs;
      if (getJobIds(state.selectedJobs).includes(action.data.job.orgJobId)) {
        newJobs = state.selectedJobs.filter(job => job.orgJobId !== action.data.job.orgJobId);
      } else {
        newJobs = [...state.selectedJobs, action.data.job];
      }

      const newJobIds = getJobIds(newJobs);
      const selectedJobsLength = action.data.orgJobs.filter(job => newJobIds.includes(job.orgJobId));

      return {
        ...state,
        selectedJobs: newJobs
      };
    }
    case TOGGLE_SHOW_SELECTED_JOBS: {
      return {
        ...state,
        isSelected: !state.isSelected
      };
    }
    case GET_JOB_UDFS_START: {
      return {
        ...state,
        isUserDefinedFieldsLoading: true,
        isUserDefinedFieldsLoaded: false
      };
    }
    case GET_JOB_UDFS_SUCCESS: {
      return {
        ...state,
        userDefinedFields: action.userDefinedFields,
        isUserDefinedFieldsLoading: false,
        isUserDefinedFieldsLoaded: true,
        hasGetUserDefinedFieldsError: false
      };
    }
    case GET_JOB_UDFS_FAILED: {
      return {
        ...state,
        isUserDefinedFieldsLoading: false,
        hasGetUserDefinedFieldsError: true,
        isUserDefinedFieldsLoaded: false
      };
    }
    case UPDATE_SELECTED_JOB_MATCHES: {
      const selectedJob = state.selectedJob;
      selectedJob.jobMatches = action.jobMatches;
      return {
        ...state,
        selectedJob
      };
    }
    case UPDATE_JOB_MATCHES_VALUES_START: {
      return {
        ...state,
        isSummaryUpdated: false,
        isUpdatingJobMatchesValues: true
      };
    }
    case UPDATE_JOB_MATCHES_VALUES_SUCCESS: {
      return {
        ...state,
        isSummaryUpdated: action.isSummaryUpdated,
        isUpdatingJobMatchesValues: false,
        isUpdatingJobMatchesValuesFailed: false
      };
    }
    case UPDATE_JOB_MATCHES_VALUES_FAILED: {
      return {
        ...state,
        isSummaryUpdated: false,
        isUpdatingJobMatchesValues: false,
        isUpdatingJobMatchesValuesFailed: true
      };
    }
    case GET_ORG_JOBS_BY_ID_START: {
      return {
        ...state,
        isLoading: true
      };
    }
    case GET_ORG_JOBS_BY_ID_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        jobs: action.jobs
      };
    }
    case GET_ORG_JOBS_BY_ID_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoadingFailed: true
      };
    }
    case GET_AGING_FACTORS_START: {
      return {
        ...state,
        isAgingFactorsLoading: true,
        isAgingFactorsLoaded: false
      };
    }
    case GET_AGING_FACTORS_SUCCESS: {
      return {
        ...state,
        isAgingFactorsLoading: false,
        isAgingFactorsLoadFailed: false,
        agingFactors: action.agingFactors,
        isAgingFactorsLoaded: true
      };
    }
    case GET_AGING_FACTORS_FAILED: {
      return {
        ...state,
        isAgingFactorsLoading: false,
        isAgingFactorsLoadFailed: true,
        isAgingFactorsLoaded: false
      };
    }
    default:
      return { ...state };
  }
}

export const orgJobsActions = {};
